import React from "react";
import MISMATCH1 from "../../../assets/images/mismatch1.png";
import MISMATCH2 from "../../../assets/images/mismatch2.png";

// /document-api?i=what-is-a-mismatch
export default function WhatIsAMismatch() {
  return (
    <>
              <p>
                A <b className="text-purple">mismatch transaction</b> refers to
                a deposit transaction that contains{" "}
                <b>incorrect or inconsistent information</b> compared to the
                expected customer or account details. Such transactions are
                automatically flagged by the system based on a set of validation
                rules.
              </p>
              <hr />
              <h5 className="fw-bold">Mismatch Validation Rules</h5>
              <p>
                The system performs automatic checks against up to four key
                attributes:
              </p>
              <div className="row">
                <div className="mb-2 fw-bold col-4">Field</div>
                <div className="mb-2 fw-bold col-4">Description</div>
                <div className="mb-2 fw-bold col-4">Required by Default</div>
                <div className="col-12">
                  <hr className="mt-0 mb-1" />
                </div>
                <div className="mb-2 fw-bold col-4">Account Name (TH)</div>
                <div className="mb-2 col-4">
                  The account holder's name in Thai
                </div>
                <div className="mb-2 col-4">✅ Required</div>
                <div className="mb-2 fw-bold col-4">Account Name (EN)</div>
                <div className="mb-2 col-4">
                  The account holder's name in English
                </div>
                <div className="mb-2 col-4">✅ Required</div>
                <div className="mb-2 fw-bold col-4">Account Number</div>
                <div className="mb-2 col-4">
                  The customer's registered bank account number
                </div>
                <div className="mb-2 col-4">Optional</div>
                <div className="mb-2 fw-bold col-4">Bank</div>
                <div className="mb-2 col-4">
                  The customer's registered bankcode
                </div>
                <div className="mb-2 col-4">Optional</div>
              </div>
              <hr />
              <p>
                If an enabled check fails (for example, the payer's account
                does not match the customer's registered details), the
                transaction will be automatically marked as{" "}
                <b className="text-purple">mismatch</b>.
              </p>
              <ul>
                <li>
                  Name checks pass if the payer name matches either the Thai or
                  the English account name (similar names are accepted).
                </li>
                <li>
                  <b>Account Number</b> and <b>Bank</b> must match exactly.
                </li>
                <li>At least two checks must be enabled.</li>
                <li>
                  Depending on your account settings, a customer's first
                  mismatching deposit may be accepted as success; later ones are
                  flagged as mismatch.
                </li>
              </ul>

              <h5 className="fw-bold">Configuring Mismatch Validation</h5>
              <p>
                You can customize which fields the system validates for mismatch
                detection:
              </p>
              <p>1. Log in to your merchant dashboard.</p>
              <p>
                2. Navigate to{" "}
                <b>“Settings” → “Mismatch Check Configuration”</b>
              </p>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="MISMATCH"
                  src={MISMATCH1}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <p>
                3. Enable or disable the validation fields according to your
                business requirements.
              </p>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="MISMATCH"
                  src={MISMATCH2}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>

              <h5 className="fw-bold">Example</h5>
              <p>For example:</p>
              <p>
                If you enable <b>Account No</b>, the system will verify whether
                the customer's <b>bank account number</b> used during the QR
                code generation for deposit matches the one used in the actual
                bank transaction.
              </p>
    </>
  );
}
